module.exports = __webpack_public_path__ + "img/banner4.669e132f.png";